<template>
  <div id="app">
    <Header v-if="['/terms', '/sitemap', '/mobilePayment'].indexOf($route.path) < 0 " />

    <!-- <div v-if="isLoading">Loading</div> -->
    <router-view></router-view>
    <Footer
      v-if="['/checkout/'+$route.params.movieID+'/'+$route.params.scheduleID+'/'+$route.params.seatLayout,'/terms', '/sitemap', '/mobilePayment', '/event_seat_layout'].indexOf($route.path) < 0"
    />
  </div>
</template>




<script>
import Vue from "vue";
import VueRouter from "vue-router";
import { Slide } from "vue-burger-menu";
import Header from "@/components/partials/header.vue";
import Footer from "@/components/partials/footer.vue";
import VueYouTubeEmbed from "vue-youtube-embed";
import Vuex, { mapState, mapGetters, mapActions } from "vuex";

Vue.use(VueYouTubeEmbed);
Vue.use(VueRouter);

export default {
  components: {
    Header,
    Footer,
    Slide
  },
  name: "app",
  data() {
    return {
      isLoading: true
    };
  },
  beforeMount() {
    document.getElementById("indexLoader").style.display = "none";
  },
  mounted() {
    let self = this;
    setTimeout(() => {
      this.isLoading = false;
    }, 3000);
  },
  computed: {
    ...mapGetters(['isRTL'])
  }
};
</script>



// WEBPACK FOOTER //
// src/App.vue